import AddEditLocation from "./AddEditLocation";

export default AddEditLocation;